:host {
    display: inline-block;
    background-color: var(--color-text);
    opacity: 0.1;
    border-radius: 12px;
    white-space: pre;
    color: transparent;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
    max-width: 100%;
}
